// Gestor de caché
(function () {
    const VERSION_SITIO = '08.10.2026.01';
    const CLAVE_VERSION = 'ph_version_tienda';
    const limpiezaTotal = false;

    const DATOS_A_PRESERVAR = [
        'mp-ver',
        'ph-datos-usuario',
        'ph-metodo-entrega',
        "ph-tipo-usuario"
    ];

    function borrarTodasLasCookies() {
        document.cookie.split(";").forEach(function (cookie) {
            document.cookie = cookie
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
        });
    }

    async function limpiarTodo() {
        try {
            localStorage.clear();
            sessionStorage.clear();
            borrarTodasLasCookies();

            if ('caches' in window) {
                const nombresCache = await caches.keys();
                await Promise.all(nombresCache.map(nombre => caches.delete(nombre)));
            }
            if (!window.location.pathname.includes('/products/')) {
                window.location.replace('/');
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error al limpiar todo:', error);
            if (!window.location.pathname.includes('/products/')) {
                window.location.replace('/');
            } else {
                window.location.reload();
            }
        }
    }

    function limpiarSelectivo() {
        const versionGuardada = localStorage.getItem(CLAVE_VERSION);

        if (!versionGuardada || versionGuardada !== VERSION_SITIO) {
            console.log('Limpiando cache de forma selectiva...');

            const datosImportantes = {};
            DATOS_A_PRESERVAR.forEach(clave => {
                const valor = localStorage.getItem(clave);
                if (valor !== null) {
                    datosImportantes[clave] = valor;
                    console.log(`Preservando: ${clave}`);
                }
            });

            localStorage.clear();
            sessionStorage.clear();
            borrarTodasLasCookies();

            Object.keys(datosImportantes).forEach(clave => {
                localStorage.setItem(clave, datosImportantes[clave]);
                console.log(`Restaurado: ${clave}`);
            });

            localStorage.setItem(CLAVE_VERSION, VERSION_SITIO);
            console.log('Cache limpiado preservando datos importantes');
            if (!window.location.pathname.includes('/products/')) {
                window.location.replace('/');
            } else {
                window.location.reload();
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            if (limpiezaTotal) {
                limpiarTodo();
            } else {
                limpiarSelectivo();
            }
        });
    } else {
        if (limpiezaTotal) {
            limpiarTodo();
        } else {
            limpiarSelectivo();
        }
    }
})();

// Redirecciones
if (window.location.pathname === '/sucursales' || window.location.pathname === '/sucursales/') {
    window.location.href = '/';
}

if (window.location.pathname.includes('/pages/perfil')) {
    const datosUsuario = localStorage.getItem('ph-datos-usuario');
    if (!datosUsuario) {
        window.location.href = '/pages/iniciar-sesion';
    }
}

if (window.location.pathname.includes('/pages/checkout-ph')) {
    const datosUsuario = localStorage.getItem('ph-datos-usuario');
    if (!datosUsuario) {
        window.location.href = '/pages/iniciar-sesion';
    }
}
